import { render, staticRenderFns } from "./VStatExport.vue?vue&type=template&id=b488a134&"
import script from "./VStatExport.vue?vue&type=script&lang=js&"
export * from "./VStatExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports